const ActionStatus = {
  UNSTARTED: {
    id: 'unstarted',
    value: -1
  },
  STARTED: {
    id: 'started',
    value: 1
  },
  ENDED: {
    id: 'ended',
    value: 2
  },
  SINGULAR: {
    id: 'singular',
    value: 3
  }
};

export { ActionStatus };
